import request from '@/utils/request'
import Setting from '../settings'
let {
  interFaceDomain
} = Setting
// interFaceDomain='https://www.fastmock.site/mock/cf1802fc35660832efb2c75bb17a13c9/jdFront'
// 获取验证码
export function getCode(params) {
  return request({
    url: interFaceDomain + '/front/user/sendEmailCode',
    method: 'get',
    params
  })
}
// 校验邮箱唯一性
export function checkEmail(params) {
  return request({
    url: interFaceDomain + '/front/user/checkEmailOnly',
    method: 'get',
    params
  })
}
// 注册
export function register(data) {
  return request({
    url: interFaceDomain + '/front/user/register',
    method: 'post',
    data
  })
}
// 基本信息提交
export function updateInfo(data) {
  return request({
    url: interFaceDomain + '/front/user/updateInfo',
    method: 'post',
    data
  })
}

//登录
export function login(data) {
  return request({
    url:  interFaceDomain+'/front/user/login',
    method: 'post',
    data
  })
}
// 获取用户信息
export function basicInfo(params) {
  return request({
    url:  interFaceDomain+'/front/user/info',
    method: 'get',
    params
  })
}
// 退出
export function signOut(params) {
  return request({
    url:  interFaceDomain+'/front/user/loginOut',
    method: 'get',
    params
  })
}